import { FC } from "react";

import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import { useTheme } from "@mui/material/styles";
import CardMediaVideoPlayerWithSpeedControls from "../../../pages/media-viewer/components/player/CardMediaVideoPlayerWithSpeedControls";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import DialogContent from "@mui/material/DialogContent";

interface VideoDialogProps {
  videoUrl: string | null;
  expanded: boolean;
  fullWidth?: boolean;
  toggleExpand: () => void;
}

const VideoDialog: FC<VideoDialogProps> = ({
  videoUrl,
  expanded,
  fullWidth,
  toggleExpand,
}) => {
  const theme = useTheme();
  const { width: screenWidth } = useWindowDimensions();

  const getMaxWidth = () => {
    if (fullWidth) {
      return "100%";
    }

    if (screenWidth > theme.breakpoints.values.xxl) {
      return theme.breakpoints.values.xl + "px";
    }

    return theme.breakpoints.values.lg + "px";
  };

  const getWidth = () => {
    return expanded ? "100%" : "100%";
  };

  return (
    <Dialog
      fullWidth
      open={expanded}
      onClose={toggleExpand}
      PaperProps={{
        sx: {
          width: getWidth(),
          maxWidth: getMaxWidth(),
          borderRadius: "8px",
        },
      }}
    >
      <Box sx={{ position: "absolute", zIndex: 3, right: 8, top: 8 }}>
        <IconButton onClick={toggleExpand}>
          <CloseIcon />
        </IconButton>
      </Box>

      <DialogContent
        sx={{
          padding: 0,
          margin: "0 auto",
        }}
      >
        {videoUrl && (
          <CardMediaVideoPlayerWithSpeedControls
            sx={{
              height: fullWidth ? "100vh" : "calc(100vh - 64px)",
            }}
            controls
            src={videoUrl}
            autoPlay
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default VideoDialog;
